import {LitElement, svg, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {when} from 'lit/directives/when.js';
import {connect} from 'pwa-helpers';
import store from '../../../store';
import {pimText, getValueOfFeature} from '../../../util/values';
import {selectHasBuriedBase, selectHeightDecided, selectIsOnesided, selectModulePosPx, selectSpcConfiguration} from '../../../selectors';

@customElement('svg-housingcolour')
export class SvgOptics extends connect(store)(LitElement) {

	static styles = css`
		:host {
			display: flex;
			width: 65%;
			height: auto;
		}

		svg {
			width: 100%;
			height: auto;
		}

	`;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.spConfiguration = selectSpcConfiguration(state);
		this.translations = state.productData.translations;
		this.lang = state.status.lang;
		this.status = state.status;
	}

	render() {
		const s = this.state;
		const svgPath = this.status.host + this.status.baseUrl + '/visuals/housingcolour.svg';
		const housingColour = getValueOfFeature('shared::ColourCoating::HS_HousingColour', this.spConfiguration) ?? 'Custom';
		const label = pimText(this.lang, 'shared::ColourCoating::HS_HousingColour', 'FV.S', this.spConfiguration, this.translations);

		return svg`
			<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="350" height="140" viewBox="0 0 350 140">
				<title>housingcolour</title>
				<defs>
					<mask id="mask-2" fill="white">
						<g transform="translate(56.5,56.5) translate(-56.5,-56.5)">
							<ellipse id="path-3" rx="56.5" ry="56.5" transform="translate(56.5,56.5)"/>
						</g>
					</mask>
				</defs>
				<g id="housingcolour" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(211.023,56.5) translate(-56.5,-56.5)">
					<g id="Mask" fill="#E6E6E6" transform="translate(56.5,56.5) translate(-56.5,-56.5)">
						<ellipse id="path-2" rx="56.5" ry="56.5" transform="translate(56.5,56.5)"/>
					</g>
					<g id="HS_HousingColour" mask="url(#mask-2)" transform="translate(56.5,56.5) translate(-56.5,-56.5)">
						<use href="${svgPath}#${housingColour}"></use>
					</g>
				</g>
			    <path id="line" d="M-41,0L-145,0" stroke="#313131" fill="none" stroke-linecap="square" stroke-width="2" transform="translate(155.5,56.5)"/>
			    <text id="label" fill="#c6c6c6" font-size="14" font-family="Lineto Brown Pro Light, sans-serif" letter-spacing="0" word-spacing="0" stroke="none" text-anchor="middle" transform="translate(211.023,136.5)" style="line-height: 16px; white-space: pre; -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; user-select: none;">${label}</text>
			</svg>
		`;
	}
}
